import { h, Fragment } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { Slides } from "./slides";
import { SliderNav } from "./SliderNav";

const timeout = 10000;

function Slider({ slides }) {
  const [activeSlideId, setActiveSlideId] = useState(0);
  let interval = useRef()

  var nextSlide = ()=>{
    setActiveSlideId((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  }

  var nextSlideGui = (id) => {
    setActiveSlideId(id);
    clearInterval(interval.current);
    interval.current = setInterval(nextSlide, timeout);
  }

  useEffect(() => {
    interval.current = setInterval(nextSlide, timeout);
    return () => {
      clearInterval(interval.current);
    };
  }, []);

  return (
    <>
      <div class="g-wrapper">
        <div class="index__wrapper">
          <div class="index__wrapper-slider">
            <Slides
              slides={slides}
              activeSlideId={activeSlideId}
              setActiveSlideId={nextSlideGui}
            />
          </div>
        </div>
      </div>
      <SliderNav
        activeSlideId={activeSlideId}
        setActiveSlideId={nextSlideGui}
      />
    </>
  );
}

export { Slider };
